import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { BRAND_NAME, navItems } from '../data/site';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ease-calm ${scrolled ? 'border-b border-sand-dark/40 bg-ivory/90 backdrop-blur-md' : 'border-b border-transparent bg-gradient-to-b from-ocean-deep/45 to-transparent'}`} data-id="element-123" data-mp="36a0bjbsm18sm">
      <div className="mx-auto flex h-[72px] max-w-[1400px] items-center justify-between px-5 sm:px-8 lg:h-20 lg:px-12" data-id="element-124" data-mp="2wl4d6jrsvud1">
        <a href="#home" className={`font-serif text-xl leading-none tracking-[0.18em] transition-colors duration-500 sm:text-2xl ${scrolled ? 'text-forest-deep' : 'text-ivory'}`} data-id="element-125" data-mp="2rk6n7l0jtw0z">
          {BRAND_NAME}
        </a>

        <nav aria-label="Primary" className="hidden lg:block" data-id="element-126" data-mp="3fblttpzcyzi1">
          <ul className="flex items-center gap-9" data-id="element-127" data-mp="3fd6nlddumeeu">
            {navItems.map(item => <li key={item.label} data-id="element-128" data-mp="3aec56cjsmrv9">
                <a href={item.href} className={`group relative text-[12px] font-medium uppercase tracking-[0.16em] transition-colors duration-300 ${scrolled ? 'text-forest-deep/75 hover:text-forest-deep' : 'text-ivory/85 hover:text-ivory'}`} data-id="element-129" data-mp="35l0v82jopuz4">
                  {item.label}
                  <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-gold transition-all duration-300 ease-calm group-hover:w-full" data-id="element-130" data-mp="1reme0jc9g0g6" />
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-3" data-id="element-131" data-mp="1hn8kcs6zpuuy">
          <a href="#book" className={`hidden rounded-full px-6 py-3 text-[11px] font-semibold uppercase tracking-[0.18em] transition-all duration-300 ease-calm sm:inline-block ${scrolled ? 'bg-ocean text-ivory hover:bg-ocean-deep' : 'bg-ivory/95 text-forest-deep hover:bg-ivory'} hover:-translate-y-0.5 hover:shadow-lift`} data-id="element-132" data-mp="1mml597eawruw">
            Book your stay
          </a>

          <button type="button" onClick={() => setMenuOpen(true)} aria-label="Open menu" className={`rounded-full border p-2.5 transition-colors lg:hidden ${scrolled ? 'border-forest-deep/20 text-forest-deep' : 'border-ivory/40 text-ivory'}`} data-id="element-133" data-mp="13o8u5g3tx7wo">
            <Menu className="h-5 w-5" data-id="element-134" data-mp="hgcyf17a3h6w" />
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-135" data-mp="w4zmbraz1h9q">
        {menuOpen && <motion.div className="fixed inset-0 z-[60] bg-forest-deep lg:hidden" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-136" data-mp="w5slo77lp4hu">
            <div className="flex h-[72px] items-center justify-between px-5 sm:px-8" data-id="element-137" data-mp="106ulap5fjikc">
              <span className="font-serif text-xl tracking-[0.18em] text-ivory" data-id="element-138" data-mp="1f3287x882y3b">
                {BRAND_NAME}
              </span>
              <button type="button" onClick={() => setMenuOpen(false)} aria-label="Close menu" className="rounded-full border border-ivory/30 p-2.5 text-ivory" data-id="element-139" data-mp="1a5k54ngvzd38">
                <X className="h-5 w-5" data-id="element-140" data-mp="3bxyjjck81zew" />
              </button>
            </div>

            <nav aria-label="Mobile" className="px-5 pt-8 sm:px-8" data-id="element-141" data-mp="22yfb81wv046s">
              <ul className="space-y-1" data-id="element-142" data-mp="27wp76eqer8tg">
                {navItems.map((item, i) => <motion.li key={item.label} initial={{
              opacity: 0,
              y: 12
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.05 + i * 0.05,
              duration: 0.4
            }} data-id="element-143" data-mp="2cwlbyg6xj4a2" data-mpi={i}>
                    <a href={item.href} onClick={() => setMenuOpen(false)} className="block border-b border-ivory/10 py-4 font-serif text-3xl text-ivory" data-id="element-144" data-mp="1p7a5ci2wefo0">
                      {item.label}
                    </a>
                  </motion.li>)}
              </ul>

              <a href="#book" onClick={() => setMenuOpen(false)} className="mt-10 block rounded-full bg-gold px-6 py-4 text-center text-[12px] font-semibold uppercase tracking-[0.18em] text-forest-deep" data-id="element-145" data-mp="11h6c94nc5yb9">
                Book your stay
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}